import customerInstance from '../../instance'

const getDeliveryConfigAllPolygon = (page, size) => {
  return customerInstance.get('/deliveryPolygonConfigs/' + ((page || size) ? '?page=' + page + '&size=' + size : ''))
}

export default getDeliveryConfigAllPolygon
